import { MAPS_URL, ADDRESS_FULL, GEO_LATITUDE, GEO_LONGITUDE } from '../../../lib/businessInfo';

const EMBED_URL = `https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2000!2d${GEO_LONGITUDE}!3d${GEO_LATITUDE}!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDbCsDA5JzM4LjciTiAxMjPCsDU0JzM5LjYiVw!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus`;

export default function ContactMap() {
  return (
    <div className="bg-white rounded-xl shadow-sm overflow-hidden">
      <div className="aspect-[16/9] relative">
        <iframe
          src={EMBED_URL}
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Rockhound Auto Location"
        />
      </div>
      <div className="p-6">
        <h3 className="font-semibold text-gray-900 mb-2">Visit Our Showroom</h3>
        <p className="text-gray-600 mb-4">{ADDRESS_FULL}</p>
        <a
          href={MAPS_URL}
          target="_blank"
          rel="noopener noreferrer nofollow"
          className="inline-flex items-center gap-2 text-[#0d6b5e] hover:text-[#0a5549] font-medium transition-colors whitespace-nowrap"
        >
          Get Directions
          <i className="ri-external-link-line"></i>
        </a>
      </div>
    </div>
  );
}
